var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    id: "Filled_Outline",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22,10L22,10c0,1.657,1.343,3,3,3h3c1.657,0,3,1.343,3,3v0c0,1.657-1.343,3-3,3H10c-1.657,0-3-1.343-3-3v0   c0-1.657,1.343-3,3-3h0c1.658,0,3.001-1.344,3-3.002v0C12.999,8.342,11.656,7,10,7H4C2.343,7,1,5.657,1,4v0c0-1.657,1.343-3,3-3h24   c1.657,0,3,1.343,3,3v0c0,1.657-1.343,3-3,3h-3C23.343,7,22,8.343,22,10z",
    fill: "#C9F9FB"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28,12h-3c-1.103,0-2-0.897-2-2s0.897-2,2-2h3c2.206,0,4-1.794,4-4s-1.794-4-4-4H4C1.794,0,0,1.794,0,4s1.794,4,4,4h6    c1.103,0,1.999,0.896,2,1.999c0,0.535-0.208,1.037-0.586,1.415C11.037,11.792,10.534,12,10,12c-2.206,0-4,1.794-4,4s1.794,4,4,4    h18c2.206,0,4-1.794,4-4S30.206,12,28,12z M28,18H10c-1.103,0-2-0.897-2-2s0.897-2,2-2c1.068,0,2.073-0.417,2.829-1.172    c0.756-0.756,1.172-1.761,1.171-2.83C13.999,7.793,12.204,6,10,6H4C2.897,6,2,5.103,2,4s0.897-2,2-2h24c1.103,0,2,0.897,2,2    s-0.897,2-2,2h-3c-2.206,0-4,1.794-4,4s1.794,4,4,4h3c1.103,0,2,0.897,2,2S29.103,18,28,18z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 10,
    x: 22,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 18,
    y: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,22H3c-0.552,0-1-0.449-1-1s0.448-1,1-1h1v-2H3c-1.654,0-3,1.346-3,3s1.346,3,3,3h10c0.552,0,1,0.449,1,1s-0.448,1-1,1    H8v2h5c1.654,0,3-1.346,3-3S14.654,22,13,22z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 4,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 2,
    y: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,29c0,1.654,1.346,3,3,3h3v-2h-3c-0.552,0-1-0.449-1-1s0.448-1,1-1h7v-2h-7C19.346,26,18,27.346,18,29z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 30,
    y: 26
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.1615921051611a7dc331d46ffc8a40cd.svg";
export { ForwardRef as ReactComponent };